import React, { ReactNode } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { State } from '../../../../constants/EventState'
import { Event } from '../../../../model/Event'

const BlinkingBorder = keyframes`
  from {
    border-color: #c4093a;
  }

  to {
    border-color: #fff;
  }
`

interface IWrapperProps {
  state: string
}

const HighlightCss = css`
  -webkit-animation-name: ${BlinkingBorder};
  -webkit-animation-duration: .8s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-name: ${BlinkingBorder};
  animation-duration: .8s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`

const Wrapper = styled.div<IWrapperProps>`
  display: flex;
  flex: 1;
  background: #fff;
  padding: 1rem 0;
  align-items: center;
  border-left: 1.4rem solid ${(props) => {
    switch (props.state) {
      case State.Negative:
        return '#c4093a'
      case State.Highlight:
        return '#c4093a'
      default:
        return '#52a840'
    }
  }};
  ${(props) => props.state === State.Highlight ? HighlightCss : ''}
`

interface IProps {
  event?: Event
  className?: string
  children?: ReactNode
}

const Card = ({ event, className, children }: IProps) => (
  <Wrapper state={event ? event.getState() : ''} className={className}>
    {children}
  </Wrapper>
)

export default Card
